import { FormArray, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class Validations {
    static MustMatch(controlName: string, checkControlName: string): ValidatorFn {
        return (controls: AbstractControl) => {
            const control = controls.get(controlName);
            const checkControl = controls.get(checkControlName);

            if (checkControl.errors && !checkControl.errors.matching) {
                return null;
            }

            if (control.value !== checkControl.value) {
                controls.get(checkControlName).setErrors({ matching: true });
                return { matching: true };
            } else {
                return null;
            }
        };
    }

    static Email(control: AbstractControl): {[key: string]: any} {

        let emailRegexp = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/;

        if (control.value && !emailRegexp.test(control.value)) { return {email: true}; }

        return null;
    }

    static Url(control: AbstractControl): {[key: string]: any} {

        let urlRegexp = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,3}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

        if (control.value && !urlRegexp.test(control.value)) { return {url: true}; }

        return null;
    }

    static MinSelectedCheckBoxes(min = 1) {
        const validator: ValidatorFn = (formArray: FormArray) => {
            let controls = formArray.controls;
            let totalSelected = 0;
            
            controls.forEach(function(control) {
                if (control.value.activo){
                    totalSelected = totalSelected+1;
                }
            });
    
            return totalSelected >= min ? null : { required: true };
        };
      
        return validator;
    }

    static MinLengthArray(min = 1) {
        return (c: AbstractControl): {[key: string]: any} => {
            if (c.value.length >= min)
                return null;
    
            return { 'minLengthArray': {valid: false }};
        }
    }

    static UserFormat(control: AbstractControl): {[key: string]: any} {

        let userRegexp = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]{3,15}$/;

        if (control.value && !userRegexp.test(control.value)) { return {userformat: true}; }

        return null;
    }

    // Custom validator for strong password criteria (regex example)
    // This can be placed in a separate file for reusability
    static passwordStrengthValidator(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        if (!value) {
            return null;
        }
        const hasUpperCase = /[A-Z]/.test(value);
        const hasLowerCase = /[a-z]/.test(value);
        const hasNumeric = /[0-9]/.test(value);
        const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(value);
        const isValid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecialChar;

        return !isValid ? { passwordStrength: true } : null;
    }

    // Custom cross-field validator to check if passwords match
    // This validator is applied to the entire FormGroup
    static passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const password = control.get('password');
        const password_confirmation = control.get('password_confirmation');

        if (!password || !password_confirmation || !password_confirmation.value) {
            return null;
        }

        if (password.value !== password_confirmation.value) {
            password_confirmation.setErrors({ notEqual: true }); // Set error on the confirm field
        return { mismatch: true }; // Optional: set error on the group
        } else {
            password_confirmation.setErrors(null); // Clear error if they match
            return null;
        }
    };
}